document.addEventListener("DOMContentLoaded", function () {
  const reviewContainer = document.querySelector(".test21-review")
  const featuresTemplate = document.querySelector(".test21-features")
  const featuresClone = featuresTemplate ? featuresTemplate.cloneNode(true) : null
  const container = document.querySelector(".test21-review-container")

  function insertFeatures() {
    const featuresTarget = document.querySelector('input[name="checkout"]')
    if (
      featuresTarget &&
      featuresClone &&
      !document.querySelector(".test21-checkout-btn-wrapper .test21-features")
    ) {
      featuresTarget.insertAdjacentElement("beforebegin", featuresClone.cloneNode(true))
    }
  }

  insertFeatures()

  // observe for cart changes
  function observer_callback(list, observer) {
    for (const entry of list.getEntries()) {
      if (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") {
        if (
          entry.name.indexOf("/cart/add") > -1 ||
          entry.name.indexOf("/cart/update") > -1 ||
          entry.name.indexOf("/cart/change") > -1
        ) {
          setTimeout(function () {
            let targetDiv = document.querySelector(
              'div[data-modal-label="Cart"] > .flex.flex-col.overflow-hidden'
            )
            if (targetDiv) {
              if (document.querySelectorAll("[data-cart-items] ul li").length > 0) {
                targetDiv.classList.remove("test21-cart-empty")
              } else {
                targetDiv.classList.add("test21-cart-empty")
              }
            }

            const reviewsTarget = document.querySelector("[data-cart-footer]")
            if (reviewsTarget && reviewContainer) {
              reviewsTarget.insertAdjacentElement("afterbegin", reviewContainer)
            }

            insertFeatures()
          }, 100)
        }
      }
    }
  }

  // check for cart update
  let observer = new PerformanceObserver(observer_callback)
  observer.observe({
    entryTypes: ["resource"]
  })

  // drag events for the slider
  if (container) {
    let isDown = false
    let startX
    let scrollLeft

    container.addEventListener("mousedown", (e) => {
      // Only trigger when a card is dragged
      if (!e.target.closest(".test21-review-card")) return

      isDown = true
      container.classList.add("dragging")
      startX = e.pageX - container.offsetLeft
      scrollLeft = container.scrollLeft
    })

    container.addEventListener("mouseleave", () => {
      isDown = false
      container.classList.remove("dragging")
    })

    container.addEventListener("mouseup", () => {
      isDown = false
      container.classList.remove("dragging")
    })

    container.addEventListener("mousemove", (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - container.offsetLeft
      const walk = (x - startX) * 1.5 // scroll speed
      container.scrollLeft = scrollLeft - walk
    })

    // Mobile Touch Support
    let touchStartX = 0
    let touchScrollLeft = 0

    container.addEventListener("touchstart", (e) => {
      if (!e.target.closest(".test21-review-card")) return

      touchStartX = e.touches[0].pageX
      touchScrollLeft = container.scrollLeft
    })

    container.addEventListener("touchmove", (e) => {
      if (!e.target.closest(".test21-review-card")) return

      const touchX = e.touches[0].pageX
      const walk = (touchX - touchStartX) * 1.5
      container.scrollLeft = touchScrollLeft - walk
    })
  }
})
